import React from "react"

import classes from "@/components/LoadingSpinner/LoadingSpinner.module.css"

export const LoadingSpinner = () => {
    return (
        <svg
            className={classes.logo}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16ZM16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0Z"
                fill="url(#paint0_linear_237_1482)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_237_1482"
                    x1="0"
                    y1="0"
                    x2="32"
                    y2="32"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#7259EF" />
                    <stop offset="1" stop-color="#7259EF" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    )
}
